export const SOMETHING_WENT_WRONG = 'Something went wrong';
export const NOT_ALLOWED_CURSOR = 'not-allowed';
export const MX_COMPANY_CODE = '70';
